import { useReducer } from 'react'
import { MapInspectorContextReducer, initialState } from './map-inspector-context-reducer'
import { MapInspectorContext, MapInspectorContextDispatch } from './map-inspector-context'

export const MapInspectorProvider = ({ children }) => {
  const [state, dispatch] = useReducer(MapInspectorContextReducer, initialState)

  return (
    <MapInspectorContext.Provider value={state}>
      <MapInspectorContextDispatch.Provider value={dispatch}>
        {children}
      </MapInspectorContextDispatch.Provider>
    </MapInspectorContext.Provider>
  )
}
